
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.9 27H10.1c-2.23 0-3.728-2.347-2.84-4.448C8.685 19.18 11.922 17 15.5 17c3.578 0 6.815 2.18 8.24 5.552.889 2.1-.61 4.448-2.84 4.448zm-5.4-11c2.485 0 4.5-2.239 4.5-5s-2.015-5-4.5-5S11 8.239 11 11s2.015 5 4.5 5z","fill":"#737791"}})])
          )
        }
      }
    